export default "__VITE_ASSET__DIIQu6Vc__"